module.exports = __webpack_public_path__ + "img/c10.bdd4beef.png";